export default __webpack_public_path__ + "static/media/ui-dev.510f75c8.png";